// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productGridContainerStyle } from "@conklin/App/Components/Product/ProductGridContainer";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

productGridContainerStyle.container = {
    css: css`
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        max-width: 100%;
        width: 100%;
        background-color: ${color("common.ui1")};
        box-shadow: none;
        box-sizing: border-box;

        ${xScreen("lte", "md")} {
            border: initial;
        }
        ${xScreen("lte", "sm")} {
            margin: 0 auto;
        }
        ${xScreen("lt", "xs")} {
            max-width: 100%;
        }

        & > .top-section {
            display: flex;
            flex-direction: column;
            flex-grow: 1;

            & > .image-section {
                margin-bottom: 12px;

                &:empty {
                    display: none;
                }

                ${xScreen("lte", "md")} {
                    margin-bottom: 8px;
                }
            }
            & > .info-section {
                display: flex;
                flex-direction: column;
                flex-grow: 1;

                &:empty {
                    display: none;
                }
            }
        }
        & > .price-and-actions-section {
            ${xScreen("lte", "md")} {
                margin-left: 103px;
            }
        }
        & > .bottom-section {
            margin-top: auto;
            display: flex;
            flex-direction: column;
            gap: 12px;
        }
    `,
};
productGridContainerStyle.image = {
    css: css`
        position: relative;
        width: 100%;
        margin: 0 auto;
    `,
};
productGridContainerStyle.info = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
productGridContainerStyle.partNumbers = {
    css: css`
        display: flex;
        flex-direction: column;
        margin-bottom: 8px;
        justify-content: space-between;
        &:empty {
            margin-bottom: 0;
        }
    `,
};
productGridContainerStyle.price = {
    css: css`
        margin-bottom: 8px;
        ${({ removeMargin }: any) =>
            removeMargin &&
            css`
                margin-bottom: 0;
            `}
    `,
};
productGridContainerStyle.availability = {
    css: css`
        margin-top: auto;
        margin-bottom: 8px;
        &:empty {
            margin-bottom: 0;
        }
    `,
};
productGridContainerStyle.addToCartActions = {
    css: css`
        margin-top: auto;
    `,
};
productGridContainerStyle.addToList = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        &:empty {
            display: none;
        }
    `,
};
productGridContainerStyle.qtyInfo = {
    css: css`
        display: flex;
        column-gap: 16px;
        margin-bottom: 8px;
        &:empty {
            display: none;
        }
        ${xScreen("lte", "sm")} {
            margin-bottom: 0;
        }
    `,
};
